var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16L6.46967 16.5303L7 17.0607L7.53033 16.5303L7 16ZM7.75 1C7.75 0.585787 7.41421 0.25 7 0.25C6.58579 0.25 6.25 0.585787 6.25 1L7.75 1ZM1 10L0.46967 10.5303L6.46967 16.5303L7 16L7.53033 15.4697L1.53033 9.46967L1 10ZM7 16L7.53033 16.5303L13.5303 10.5303L13 10L12.4697 9.46967L6.46967 15.4697L7 16ZM7 16L7.75 16L7.75 1L7 1L6.25 1L6.25 16L7 16Z",
    fill: "#9061DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrow);
export default __webpack_public_path__ + "static/media/DownloadArrow.bdb9350eda14a745636974e942e0d3a6.svg";
export { ForwardRef as ReactComponent };